import { useRef } from "react";
import "./styles.css";

interface FilesInputProps {
    files: File[];
    existingUrls?: string[];
    onChange: (files: File[]) => void;
    onRemoveExisting?: (url: string) => void;
    accept?: string;
    maxFiles?: number;
    inputRef?: React.RefObject<HTMLInputElement | null>;
}

export default function FilesInput({
    files,
    existingUrls = [],
    onChange,
    onRemoveExisting,
    accept = "image/*",
    maxFiles = 10,
    inputRef,
}: FilesInputProps) {
    const internalRef = useRef<HTMLInputElement>(null);
    const fileInputRef = inputRef || internalRef;

    const totalCount = existingUrls.length + files.length;

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = Array.from(e.target.files || []);
        const remainingSlots = maxFiles - totalCount;
        const filesToAdd = selectedFiles.slice(0, remainingSlots);
        onChange([...files, ...filesToAdd]);
        e.target.value = "";
    };

    const handleRemoveFile = (index: number) => {
        const newFiles = [...files];
        newFiles.splice(index, 1);
        onChange(newFiles);
    };

    const handleRemoveExisting = (url: string) => {
        if (onRemoveExisting) {
            onRemoveExisting(url);
        }
    };

    return (
        <div className="files-input">
            <input ref={fileInputRef} type="file" accept={accept} multiple onChange={handleFileChange} className="files-input-hidden" />

            <div className="files-input-grid">
                {existingUrls.map((url, index) => (
                    <div key={`existing-${index}`} className="files-input-preview">
                        <img src={url} alt="" className="files-input-image" />
                        <button type="button" className="files-input-delete" onClick={() => handleRemoveExisting(url)}>
                            <img src="/icons/delete-icon.svg" alt="" width={14} height={14} />
                        </button>
                    </div>
                ))}

                {files.map((file, index) => (
                    <div key={`file-${index}`} className="files-input-preview">
                        <img src={URL.createObjectURL(file)} alt="" className="files-input-image" />
                        <button type="button" className="files-input-delete" onClick={() => handleRemoveFile(index)}>
                            <img src="/icons/delete-icon.svg" alt="" width={14} height={14} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
